import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {DriverActivity, DriverActivityEntity} from "../../../model/driver-activity";

export interface DriverActivitySelectorProps {
  personId?: string
  withCVDs?: boolean
}

const getPersonIdParam = createParamSelector<DriverActivitySelectorProps | undefined, string | undefined>(params => params?.personId);
const getWithCVDsParam = createParamSelector<DriverActivitySelectorProps | undefined, boolean | undefined>(params => params?.withCVDs);


export const driverActivitiesSelector = () => createSelector(
  [getUseQueryResultData<DriverActivity[]>, getPersonIdParam, getWithCVDsParam],
  (data, personId, withCVDs) => {
    return selectDriverActivitiesAndTransform(
      data ?? [], {
        personId: personId,
        withCVDs: withCVDs,
      }
    );
  }
);

export const driverActivitySelector = () => createSelector(
  [getUseQueryResultData<DriverActivity>],
  (data) => {
    return data ? transformDriverActivity(data) : undefined;
  }
);

export const selectDriverActivities = (values?: DriverActivityEntity[], selector?: DriverActivitySelectorProps): DriverActivityEntity[] => {
  if (!values) {
    return [];
  }

  return values.filter((a) => {
    let filterIn = true;

    if (selector?.personId) {
      if (selector.personId !== a.personId) {
        filterIn = false;
      }
    }

    if (typeof selector?.withCVDs !== 'undefined' && !selector.withCVDs) {
      if (a.containerVolumeDrop) {
        filterIn = false
      }
    }

    return filterIn;
  });
};

export const transformDriverActivity = (value: DriverActivity): DriverActivityEntity => {
  return DriverActivityEntity.from(value)
}

export const selectDriverActivitiesAndTransform = (values?: DriverActivity[], selector?: DriverActivitySelectorProps): DriverActivityEntity[] => {
  const transformed = values?.map(transformDriverActivity)
  return selectDriverActivities(transformed, selector);
};
